import React, {useEffect, useState, useMemo, useContext } from "react";
import { jobOrderColNm } from "constants/jobOrderConstant";
import { Box, Dialog, DialogContent } from "@mui/material"
import { DialogHeader, DialogFooter } from "components/dialog/DialogHeader";
import PaperComponent from "components/PaperComponent";
import ComboBox from "components/ComboBox";
import { modifyPOICombo } from "branch/functions/modifyPOICombo";
import { GlobalStateContext } from "contexts/GlobalStateContext";

const UpdatePOIDialog = ({ jobOrdIds, colName, oldData, updateColumn, setDialogOpen, dialogOpen, selectedRow }) => {
  const [colData, setColData] = useState(null);

  const {msData} = useContext(GlobalStateContext)
  const colType = useMemo(()=>{
    if(colName === "TakePOIId"){
      return "TAKE"
    } else if(colName === "RtnPOIId"){
      return "RTN"
    } else {
      return "LOC"
    }
  }, [colName])

  useEffect(()=>{
    if(dialogOpen){
      
      setColData(oldData)
    } else {
      setColData("")
    }
  }, [oldData, dialogOpen])

  const handleUpdateColumn = () =>{
    updateColumn(colName, {[colName]:colData}, jobOrdIds)
    setDialogOpen(false)
  }
  
  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xs' >
      <DialogHeader  handleDialogClose={() => setDialogOpen(false)}
        title={`แก้ไขข้อมูล ${jobOrderColNm[colName]}`}
        onDeleteClick={null}
      />
      <DialogContent>
        <Box display='flex' flexDirection='column' gap={1} mt={1}>
        <ComboBox options={modifyPOICombo(msData.poiCombo, colType, selectedRow?.ShpmTypId|| 1)}
          sx={{ width: "100%" }}
          label={jobOrderColNm[colName]}
          selectedId={colData}
          setSelectedId={(id) => setColData(id)} />
        </Box>
      </DialogContent>
      <DialogFooter okText={"แก้ไขข้อมูล"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleUpdateColumn} />
    </Dialog>
  )
}

export default React.memo(UpdatePOIDialog, (o, n) => o.dialogOpen === n.dialogOpen)